/**
 * Compounding method.
 * tag: 40747
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamCompoundingMethod {
  /** None */
  None = 0,
  /** Flat */
  Flat = 1,
  /** Straight */
  Straight = 2,
  /** Spread exclusive */
  SpreadExclusive = 3,
}
